/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createMonitoringIntegrationBodyTeamIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createMonitoringIntegrationBodyDefaultCustomerIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createMonitoringIntegrationBodyPriorityPolicyOnePriorityMax = 4;

export const createMonitoringIntegrationBodyPriorityPolicyTwoDefaultPriorityMax = 4;

export const CreateMonitoringIntegrationBody = zod.object({
  name: zod.string(),
  teamId: zod
    .union([zod.uuid().regex(createMonitoringIntegrationBodyTeamIdOneRegExp), zod.null()])
    .optional(),
  defaultCustomerId: zod
    .union([
      zod.uuid().regex(createMonitoringIntegrationBodyDefaultCustomerIdOneRegExp),
      zod.null(),
    ])
    .optional(),
  priorityPolicy: zod.union([
    zod.object({
      mode: zod.literal('fixed'),
      priority: zod.int().min(1).max(createMonitoringIntegrationBodyPriorityPolicyOnePriorityMax),
    }),
    zod.object({
      mode: zod.literal('payload'),
      field: zod.string().nullable(),
      defaultPriority: zod
        .int()
        .min(1)
        .max(createMonitoringIntegrationBodyPriorityPolicyTwoDefaultPriorityMax),
    }),
  ]),
  provider: zod.enum(['checkly', 'datadog', 'grafana', 'prtg']),
});

export type CreateMonitoringIntegrationBody = zod.input<typeof CreateMonitoringIntegrationBody>;
export type CreateMonitoringIntegrationBodyOutput = zod.output<
  typeof CreateMonitoringIntegrationBody
>;
